import { render, staticRenderFns } from "./dAccountEdit.vue?vue&type=template&id=046c33a4&scoped=true&lang=html&"
import script from "./dAccountEdit.vue?vue&type=script&lang=js&"
export * from "./dAccountEdit.vue?vue&type=script&lang=js&"
import style0 from "./dAccountEdit.vue?vue&type=style&index=0&id=046c33a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046c33a4",
  null
  
)

export default component.exports